export enum Granularities {
  Days = 'days',
  Weeks = 'weeks',
  Months = 'months',
  Quarters = 'quarters',
  Years = 'years',
}
